import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/ui/utils";
import { Overline } from "@repo/ui/overline";
import { Actions } from "@/components/common/actions/actions.component";
import { RichTextBodyCopySimple } from "@/components/common/rich-text/rich-text-body-copy-simple.component";
import type { BigHeaderProps } from "./big-header.types";
const spacingVariants = {
  default: "pt-20 pb-16 desktop:py-40",
  loose: "py-16 desktop:pt-40 desktop:pb-28",
  compact: "pt-6 pb-10 desktop:pt-10 desktop:pb-16"
} as const;
export function BigHeader(t0) {
  const $ = _c(39);
  const {
    overline,
    headline,
    body,
    action,
    alignment: t1,
    spacing: t2,
    className
  } = t0;
  const alignment = t1 === undefined ? "center" : t1;
  const spacing = t2 === undefined ? "default" : t2;
  const isCenter = alignment === "center";
  let t3;
  if ($[0] !== action) {
    t3 = action ? [action] : undefined;
    $[0] = action;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const actions = t3;
  let t4;
  if ($[2] !== className) {
    t4 = cn("bg-surface-base-primary", className);
    $[2] = className;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = spacingVariants[spacing];
  let t6;
  if ($[4] !== t5) {
    t6 = cn("container-grid", t5);
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = isCenter ? "items-center text-center" : "items-start text-left";
  let t8;
  if ($[6] !== t7) {
    t8 = cn("col-span-full flex flex-col gap-8 desktop:gap-16 px-2 desktop:px-0", t7);
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const t9 = isCenter ? "items-center" : "items-start";
  let t10;
  if ($[8] !== t9) {
    t10 = cn("flex flex-col gap-6 desktop:gap-12", t9);
    $[8] = t9;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const t11 = isCenter ? "items-center desktop:max-w-[866px]" : "items-start desktop:max-w-[866px]";
  let t12;
  if ($[10] !== t11) {
    t12 = cn("flex flex-col gap-4", t11);
    $[10] = t11;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  let t13;
  if ($[12] !== overline) {
    t13 = overline && <Overline>{overline}</Overline>;
    $[12] = overline;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== headline) {
    t14 = typeof headline === "string" ? <h2 className="typography-mobile-heading-h3-voyage desktop:typography-desktop-heading-h1-voyage text-text-primary">{headline}</h2> : <RichTextBodyCopySimple richText={headline} as="heading-display" className="text-text-primary" />;
    $[14] = headline;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] !== t12 || $[17] !== t13 || $[18] !== t14) {
    t15 = <div className={t12}>{t13}{t14}</div>;
    $[16] = t12;
    $[17] = t13;
    $[18] = t14;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== body || $[21] !== isCenter) {
    t16 = body && <RichTextBodyCopySimple richText={body} as="editorial-lead" className={cn("text-text-secondary", isCenter && "desktop:max-w-[866px]")} />;
    $[20] = body;
    $[21] = isCenter;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== t10 || $[24] !== t15 || $[25] !== t16) {
    t17 = <div className={t10}>{t15}{t16}</div>;
    $[23] = t10;
    $[24] = t15;
    $[25] = t16;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== actions) {
    t18 = actions && actions.length > 0 && <Actions actions={actions} />;
    $[27] = actions;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== t17 || $[30] !== t18 || $[31] !== t8) {
    t19 = <div className={t8}>{t17}{t18}</div>;
    $[29] = t17;
    $[30] = t18;
    $[31] = t8;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== t19 || $[34] !== t6) {
    t20 = <div className={t6}>{t19}</div>;
    $[33] = t19;
    $[34] = t6;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== t20 || $[37] !== t4) {
    t21 = <section className={t4} data-testid="big-header">{t20}</section>;
    $[36] = t20;
    $[37] = t4;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  return t21;
}